// Module
var code = "<div class=\"panel-body\" ng-transclude collapse=\"isCollapsed\"> </div>";
// Exports
module.exports = code;